// extracted by mini-css-extract-plugin
export default {"accordionSummary":"OfferVariationModal_accordionSummary","modal":"OfferVariationModal_modal"};